import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import moment from 'moment';
import JisTabButton from '../../components/controls/jisTabButton';
import NewGif from '../../assets/new_icon.gif';
import JisDialogForm from '../../components/formdialog';
import DeadlineBadge from '../../components/controls/deadlinebadge';
function JudgeAdrCases() {
     const navigate = useNavigate();
     const { eventtype } = useParams();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);
    const [pageIndex, setPageIndex]=useState(0);
    const [pageSize,setPageSize] = useState(Constants.PAGESIZE);
    const [isSearch, setIsSearch] =useState(false);
    const [search, setSearch]=useState(null);
    const [err,setErr]=useState('');
     const [isPreview, setIsPreview] = useState(false);
     const [count,setCount] = useState(0);
    const [active, setActive] =useState(null);
    const [index, setIndex] = useState(-1);
    const [openCase,setOpenCase] =useState(false);
    const [isCmc, setIsCmc]=useState(null);
    const [openOption, setOpenOption] = useState(false);
    const [comment, setComment] =useState('');
    const [option, setOption]=useState({});
    const [suitNumber, setSuitnumber]=useState('');
    const [selected, setSelected] = useState(new Set()); //to hold the selected 
    const [roles, setRoles] = useState([]);
    const [judges, setJudges] = useState([]);
    const [selectedCases, setSelectedCases] = useState({});
    const [assignTo,setAssignTo]=useState(null);
    const [roleCase, setRoleCase]=useState('all');
    const [caseStatus, setCaseStatus] = useState('pending');
    const [schedule, setSchedule]= useState({});
    const [judge, setJudge] = useState(null);
    const [processCase,setProcessCase]=useState('all');
    const [openClear, setOpenClear] = useState(false);
    const [clearCommnent, setClearComment] = useState('');
    const [caseStatusId, setCaseStatusId] = useState(107);
    const [predate,setPredate] = useState('');
    const [pretime,setPretime] = useState('')
      useEffect(() => {
         //onSearch(search);   
          onGetJudge() ;  
    }, []);

     useEffect(() => {
           if(pageIndex>=0){
             if(search!=null){
               onSearch(search);
             }
           }else{
             setPageIndex(0);
           }
           
                     
         }, [pageIndex,pageSize,search,caseStatus]);

    

const onCaseStateChange=(s)=>{
setCases([]);
setCaseStatus(s)
    if(s=='pending'){
      setCaseStatusId(107);
    }if(s=='schedule'){
      setCaseStatusId(161);
    }
    else if(s=="settled"){
       setCaseStatusId(135);
    }
    else if(s=="non-settled"){
       setCaseStatusId(140);
    }
    else if(s=="hearing"){
       setCaseStatusId(137);
    }
    else if(s=="un-default"){
       setCaseStatusId(158);
    }
    else if(s=="sch-default"){
       setCaseStatusId(116);
    }
    else if(s=="un-subtituded"){
       setCaseStatusId(164);
    }
    else if(s=="sch-subtituded"){
       setCaseStatusId(166);
    }
    
    
    else if(s=="struckout"){
       setCaseStatusId(160);
    }

}
const onCheck=(value,opt)=>{
        let sel=selected;
        let updateSel={...selectedCases};
        if(value){
        sel.add(opt.caseId)
        updateSel[opt.caseId]=opt;
        }else{
         sel.delete(opt.caseId);
          delete updateSel[opt.caseId];
        }
        setSelected(new Set(sel));
        setSelectedCases(updateSel)
        console.log(Object.keys(updateSel))
    }
  const onSearch=async(sear)=>{ 
            setSearch(sear)       ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/filing/adr-admin-cases/${caseStatusId}/${pageIndex}/${pageSize}`, {
                method: 'POST',
                body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
                if(pageIndex==0){
                setCount(data.totalCount)
               }
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
        }
        const onLoadRoles= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/profile/getrolesBySearch/judge`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setRoles(data.roles)
               
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }

        const onLoadUserByRoleandDivision= async()=>{
            //for account registration
        try {

            setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/profile/getUsersByRole/${option.roleId}/${option.divisionId}`, { 
                method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
            const data = await resp.json();
            setLoading(false);
            if(data.code==0){
                //ready
                // fee, feelines, cinfo , parties 
              setJudges(data.pros)
               
              
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
            
            } catch (error) {
            setLoading(false);
            console.error(error);   
            }
        }
 
         useEffect(() => {
          
          if(!(option.divisionId==null || option.divisionId=='') && !(option.roleId==null || option.roleId==''))
         {
          setAssignTo(null);
          setJudges([]);
           onLoadUserByRoleandDivision();
         }
         

    }, [option.divisionId, option.roleId]);
 const onGetJudge= async()=>{
            //for account registration
            
            try {
              setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/profile/getjudgedetails-profile`, { 
                  method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
                const data = await resp.json();
                var judge=data.judge;
                if(judge!=null){
                  setJudge({...judge, courtName:data.courtname,
                    judgeType:data.judgetype,
                  lastRank: data.lastRank,})
                  
                }
                
              } catch (error) {
                setLoading(false);
                console.error(error);   
              }
        }
      const onPagePick=(pick)=>{
    console.log('this is selection value');
    setPageIndex(pick.id-1)
    console.log(pick)
}

    const onContinue=(fee,ind)=>{
        //navigate(`/case-details/${caseid}`)
        setActive(fee);
        setIndex(ind);
        setOpenCase(true);
    }

    const onPreview=(fee,ind)=>{
        //navigate(`/case-details/${caseid}`)
        setActive(fee);
        setIndex(ind);
        setIsPreview(true);
    }

    const onCloseOpenCase=()=>{
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    }
   const onCloseClear=()=>{
    setActive(null);
    setIndex(-1);
    setOpenClear(false);
    }

   const onSave=async(e)=>{
             e.preventDefault();

             setErr('');
            // var eventtype=isCmc==true?'CMC':'Trial';
              var obj={...schedule,eventType:eventtype??'ADR',CaseId:active.caseId,CourtId:judge.courtId,CourtRoomId:0,JudgeId:profile.id};
                
            setLoading(true)
            try {
            
                const resp = await fetch(`${Constants.apiUrl}/filing/shedule-case`, {
                method: 'POST',
                body:JSON.stringify(obj) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
                setOpenOption(false)
               
                setAlert({open:true, title:'Case Schedule', subtitle:' Cases scheduled assigned successfully'});
                setPageIndex(-1); // this will auto load again
                setIsPreview(false);
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }
       } 
 
const onOptionChange = (e) => {
    setOption({...option, [e.target.name]: e.target.value})
}

 const onScheduleChange = (e) => {
    setSchedule({...schedule, [e.target.name]: e.target.value})
}

const onDirectSearch=(sear)=>{
   setSearch(sear)       ;
   setIsSearch(true);
  setPageIndex(0);
}

const onClear=(item,index)=>{
  //load a dialog with 
  setActive(item);
  setOpenClear(true);
  
}

const onSaveClear=async(e)=>{
   e.preventDefault();

    setLoading(true)
            try {
             var approve={caseid:active.caseId,comment:clearCommnent,predate,pretime};
                const resp = await fetch(`${Constants.apiUrl}/filing/adr-clear-case/judge/${active.caseId}`, {
                method: 'POST',
                body:JSON.stringify(approve) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
                setOpenClear(false)
               
                 setAlert({open:true, title:'Case Acceptance', subtitle:' Case(s) cleared  successfully'});
                setPageIndex(-1); // this will auto load again
               
                
            } else if(data.code==-10){
                setIsExpired(true);
            }else{
            //there is an error
            setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            // onMove();
            }

}

const onAdoption=(item,index)=>{
  //load a dialog with 
  setActive(item);
  setOpenClear(true);  
}
  return (
    <div>
      <CaseSearch onSearch={onDirectSearch} frequentData={frequentData} filingtype='adr' />
    

<div className='tab_body'>
    <div className='tab_section'>
        <JisTabButton code="pending" isActive={caseStatus=='pending'}  title="Pending" isRoleBased={false} onClick={()=> onCaseStateChange('pending')}/>
          <JisTabButton code="schedule" isActive={caseStatus=='schedule'}  title="Scheduled" isRoleBased={false} onClick={()=> onCaseStateChange('schedule')}/>
        <JisTabButton code="settled" isActive={caseStatus=='settled'}  title="Settlement " isRoleBased={false} onClick={()=> onCaseStateChange('settled')}/>
        <JisTabButton code="non-settled" isActive={caseStatus=='non-settled'}  title="Non-Settlement " isRoleBased={false} onClick={()=> onCaseStateChange('non-settled')}/>
        <JisTabButton code="hearing" isActive={caseStatus=='hearing'}  title="For Adoption" data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('hearing')}/>    
        <JisTabButton code="un-default" isActive={caseStatus=='un-default'}  title="Default Judgement" data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('un-default')}/> 
        <JisTabButton code="sch-default" isActive={caseStatus=='sch-default'}  title="Schedule Default Judgement" data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('sch-default')}/> 

          <JisTabButton code="un-subtituded" isActive={caseStatus=='un-subtituded'}  title="Subtituded Cases" data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('un-subtituded')}/> 
        <JisTabButton code="sch-subtituded" isActive={caseStatus=='sch-subtituded'}  title="Schedule Substituded" data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('sch-subtituded')}/> 

         <JisTabButton code="struckout" isActive={caseStatus=='struckout'}  title="Struck Out" data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('struckout')}/>     
         {/*    <JisTabButton code="concluded" isActive={caseState=='concluded'}  title="Concluded " data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('concluded')}/>    */}
    </div>
 {(caseStatus=='pending' || caseStatus=='schedule') &&  <div  className='tab_view'>
    {cases?.length==0 && <JisEmptyList/>}
    {cases?.length>0 && 
    <div className='table'>
    <div class="section-cases">
    <span>Cases</span><span className='total'>{count}</span>
    </div>
        <table class="case-table">
    <thead>
        <tr>
        <th>Suit Number</th>
        <th>Case Title</th>
        <th>Filing Type</th>
        <th>Classification</th>
        <th>Case Age(Days)</th>
        <th>Date Filed</th>
        <th>Status Level</th>
    
        <th>Details</th>
        <th>Action</th>
        <th>Schedule</th>
        </tr>
    </thead>
    <tbody>
        {cases?.map((opt, index) =>{
          const cc=Constants.getSlaTimeLeft(opt.slaExpire);
              return  (
        <tr key={index}>
        <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.colour}`}}>{opt.caseNumber}</td>
        <td>{opt.caseTitle}</td>
        <td>{Constants.getItemById(frequentData?.casetype,opt.caseTypeId)?.caseType1}</td>
        <td> {Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.categoryTitle}</td>
        <td>{moment().diff(opt.createdOn, 'days')}</td>
        <td> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
        <td>{Constants.getItemById(frequentData?.casestatuses,opt.caseStatusId)?.description}</td>
        <td><JisButton  variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
        <td>
         
          
          {opt.caseFilingId==2 && <>
          <JisButton  variant='plain' onClick={()=>onClear(opt,index)}>
        {opt.isScheduled==null && <img src={NewGif} style={{width:20,height:20}}/>}  
          Clear</JisButton>
          
          </> } 
          </td>
          <td>
{<JisButton  variant='plain' onClick={()=>onPreview(opt,index)}>
        {opt.isScheduled==null && <img src={NewGif} style={{width:20,height:20}}/>}  
          Schedule</JisButton>} 
          </td>
        </tr>
        )})} 
        


    </tbody>
    </table>
    {cases?.length>0 && <Pagenated  onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
    </div>}
</div>  } 
{(caseStatus=='settled' || caseStatus=='hearing' || caseStatus=='non-settled' 
  || caseStatus=='un-default'  
  || caseStatus=='sch-default' || caseStatus=='un-subtituded' || caseStatus=='sch-subtituded' || caseStatus=='struckout') &&  <div  className='tab_view'>
    {cases?.length==0 && <JisEmptyList/>}
    {cases?.length>0 && 
    <div className='table'>
    <div class="section-cases">
    <span>ADR Judge Cases</span><span className='total'>{count}</span>
    </div>
        <table class="case-table">
    <thead>
        <tr>
        <th>Suit Number</th>
        <th>Case Title</th>
        <th>Filing Type</th>
        <th>Classification</th>
        <th>Case Age(Days)</th>
       {/*  <th>Schedule Date</th>
        <th>Start Time</th>
        <th>End Time</th> */}
        {/* <th>SLA</th> */}
        <th> Status</th>
        <th>Details</th>
        <th>Action</th>
        </tr>
    </thead>
    <tbody>
        {cases?.map((opt, index) => {
          const cc=Constants.getSlaTimeLeft(opt.slaExpire);
                return (
        <tr key={index} >
        <td style={{backgroundColor:`${Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.colour}`}}>{opt.caseNumber}</td>
        <td>{opt.caseTitle}</td>
        <td>{Constants.getItemById(frequentData?.casetype,opt.caseTypeId)?.caseType1}</td>
        <td> {Constants.getItemById(frequentData?.casecategories,opt.caseCategoryId)?.categoryTitle}</td>
        <td>{moment().diff(opt.createdOn, 'days')}</td>

       {/*  <td> {Constants.momentDate(opt.schedule[0]?.scheduleDate)?.format('DD MMM, YYYY')}</td>
        <td> {Constants.momentTime(opt.schedule[0]?.startTime)?.format('hh:mm A')}</td>
        <td>{Constants.momentTime(opt.schedule[0]?.endTime)?.format('hh:mm A')}</td> */}
      
         {/* <td> <DeadlineBadge dateString={opt.slaExpire} /></td> */}
        <td>{Constants.getItemById(frequentData?.casestatuses,opt.caseStatusId)?.description}</td>
        <td><JisButton  variant='plain' onClick={()=>onContinue(opt,index)}>View</JisButton></td>
       {caseStatus=='settled' && <td><JisButton variant='plain' onClick={()=>onPreview(opt,index)}>Schedule</JisButton></td>}
        {caseStatus=='hearing' && <td><JisButton variant='plain' onClick={()=>onPreview(opt,index)}>Re Schedule</JisButton></td>}
         {caseStatus=='non-settled' && <td><JisButton variant='plain' onClick={()=>onAdoption(opt,index)}>Clear</JisButton></td>}
       {(caseStatus=='un-default' || caseStatus=='un-subtituded') && <td><JisButton variant='plain' onClick={()=>onPreview(opt,index)}>Schedule</JisButton></td>}
       {(caseStatus=='sch-default' || caseStatus=='sch-subtituded') && <td><JisButton variant='plain' onClick={()=>onPreview(opt,index)}>Reschedule</JisButton></td>}
        {caseStatus=='struckout' && <td><JisButton variant='plain' onClick={()=>onAdoption(opt,index)}>Struck Out</JisButton></td>}
        </tr>
        )})} 
        


    </tbody>
    </table>
    {cases?.length>0 && <Pagenated onChangePageSize={(k)=>setPageSize(k)} size={pageSize} total={count} maxPage={20}  onPick={onPagePick}/>}    
    </div>}
</div>  }

</div>

     



<BackLoader open={loading} />

    {openClear && active!=null  && <JisDialogForm title="Case Acceptance" onClose={onCloseOpenCase}>
          <form onSubmit={onSaveClear}>
          <h3>{active?.caseNumber}: {active?.caseTitle}</h3>
          {caseStatus=='pending' && <>
          <p>The case move back to ADR Admin with your minute(comment)</p>
          </>}
          {caseStatus=='struckout' && <>
          <p>Matter is struck out for want of diligent prosecution by the ADR Judge under Ord. 30 R.19 as aforesaid</p>
          </>}
          {caseStatus=='settled' && <>
          <p>The Judge send scheduled adopted case to Court Register</p>
          <div style={{display:'flex'}}>

                <div  className="input-group">
                    <label> Adoption Date</label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="date" />
                      <input
                        placeholder='Adoption Date'
                        value={predate}
                        onChange={(e)=>setPredate(e.target.value)}
                        required={true}
                        type='date'
                      />
                    </div>
                </div>
                 <div  className="input-group">
                                  <label> Adoption Time</label>
                                  <div className='input-wrapper'>
                                      <DynamicIcon iname="time" />
                                    <input
                                      placeholder='Adoption Time'
                                      value={pretime}
                                      onChange={(e)=>setPretime(e.target.value)}
                                      required={true}
                                      type='time'
                                    />
                                  </div>
                              </div>             
              </div>
          </>}
          {caseStatus=='non-settled' && <>
          <p>The case move to case re-assignment for Litigation process</p>
          </>}
          
          <div  className="input-group">
                  <label>  Comment<span className="required">*</span> </label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="group" />
                      <textarea placeholder='comment' required={true}  value={clearCommnent}
              onChange={(e) => setClearComment( e.target.value)}   />
                  </div>

              </div>
            <JisButton type="submit">Save </JisButton> 
        </form>
     </JisDialogForm>}

    {openCase && active!=null  && <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
             <CaseDetails  caseId={active.caseId} data={null} token={token} initialtab="casedocuments" />
          </div>
</JisDialogForm>}

      {openOption && <JisDialogForm title=" Case Assignment">
                    <form onSubmit={onSave}>
                      <div style={{display:'flex'}}>
                         <div style={{flex:3}}>
                           {active.caseFilingId==1 && <JisYesNo  label="Assign Case As... " value={isCmc} yes="CMC" no="Trial"  onChange={(e)=>setIsCmc(e) }/>}  
                  
                              <div>
                                      <div className="select-group">
                                        <label>
                                            Division  
                                        </label>
                                        <select name="divisionId" value={option.divisionId}  onChange={onOptionChange} required>
                                            <option value="">Select </option>
                                            {frequentData.divisions?.map((opt) => (
                                            <option key={opt.id} value={opt.id}>
                                                {opt.title}
                                            </option>
                                            ))}
                                        </select>
                                        
                                    </div>
                                    <div className="select-group">
                                        <label>
                                          Role:  
                                        </label>
                                        <select name="roleId" value={option.roleId}  onChange={onOptionChange} required>
                                            <option value="">Select Role </option>
                                          {roles?.map((opt) => (
                                            <option key={opt.id} value={opt.id}>
                                                {opt.name}
                                            </option>
                                            ))}
                                        </select>
                                        
                                    </div>
                                    <div className="select-group">
                                        <label>
                                            Judges:  
                                        </label>
                                        <div className='content-box' style={{maxHeight:300}}>
                                           {judges?.map((opt) => (
                                            <div key={opt.id}  onClick={()=>setAssignTo(opt.id)} className={`selected ${opt.id==assignTo?'active':''}`}>
                                                {opt.suffix} {opt.firstName} {opt.lastName}
                                            </div>
                                            ))}
                                        </div>
                                        
                                    </div>
                                    

                              </div> 
                            <div  className="input-group">
                                <label>Comment <span className="required">*</span> </label>
                                <div className='input-wrapper'>
                                    <DynamicIcon iname="group" />
                                    <textarea placeholder=' Comment' name='comment' required={true}  value={option.comment}
                            onChange={onOptionChange }  />
                                </div>
                            </div> 
                            {err!="" && <div className='error'>{err}</div>}

                         
                            <JisButton type="submit">Save </JisButton>     <JisButton type="button" onClick={()=> setOpenOption(false)}>Cancel </JisButton>             
                        </div>
                        <div style={{flex:1,maxHeight:300}}  className='content-box'>
                          <div>
                            Selected Cases to Assign ({Object.values(selectedCases).length})
                          </div>
                          {Object.values(selectedCases)?.map((opt,index) => (
                                            <div className='selected' key={index} >
                                              <div>{opt.caseNumber}</div> 
                                              <p style={{fontSize:12}}>{opt.caseTitle}</p> 
                                            </div>
                                            ))}
                        </div>
                      </div>
                       
                    </form>
            </JisDialogForm>}  
            
             
   {isPreview &&  <div className={  "preview open" } style={{overflow:'scroll'}}>
                <div className="heading">
                  <div className='buttongroup'>
                    <JisButton icon="close"  onClick={() => setIsPreview(false)}> Close Schedule</JisButton>
                     </div>
                  <div className='panel'>
                    <div className='title'>Schedule Case</div>
                    <div className='panel-body'>
                        <form onSubmit={onSave}>
                           <div>
                        <div  className="input-group">
                                    <label> Schedule Title <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="badge" />
                                      <input value={active.caseTitle} disabled />
                                    </div>

                                </div>
                        <div  style={{display:'flex'}}>
                                <div  className="input-group">
                                    <label> Case Number <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="badge" />
                                      <input value={active.caseNumber} disabled />
                                    </div>

                                </div>
                                <div  className="input-group">
                                    <label> Event Type</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="badge" />
                                      <input  required={true} value={eventtype??'ADR'}  disabled /> 
                                    </div>
                                </div>
                            </div>

                            <div  style={{display:'flex'}}>
                                <div  className="input-group">
                                    <label> Court </label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="email" />
                                      <input  name="courtName" value={judge?.courtName} disabled   />
                                    </div>

                                </div>
                                <div  className="input-group">
                                    <label> Room</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="chair_alt" />
                                      <input disabled required={true} value={judge?.lastRank??'000'}  /> 
                                    </div>
                                </div>
                            </div>
                                <div  style={{display:'flex'}}>
                                <div  className="input-group">
                                    <label> Schedule Date <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="calendar_clock" />
                                      <input  name="scheduleDate" type='date' required value={schedule.scheduleDate} onChange={onScheduleChange} placeholder='Date'  />
                                    </div>

                                </div>
                                <div  className="input-group">
                                    <label> Start Time<span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="acute" />
                                      <input placeholder='Start Time' type='time' name="startTime" required={true} value={schedule.startTime}  onChange={onScheduleChange}  /> 
                                    </div>
                                </div>
                                <div  className="input-group">
                                    <label> End Time<span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="chronic" />
                                      <input placeholder='Time' type='time' required={true} name='endTime' value={schedule.endTime}  onChange={onScheduleChange}  /> 
                                    </div>
                                </div>
                            </div>
                           <div  className="input-group">
                                <label> Agenda</label>
                                <div className='input-wrapper'>
                                    <textarea required={true} name="agenda" placeholder='Agenda...' value={schedule.agenda}  onChange={onScheduleChange}></textarea>
                                </div>
                            </div>
                            <div style={{textAlign:'center'}}> <JisButton type='submit'>Save Schedule</JisButton> </div>
                        </div> 
                        </form>
                       
                    </div>
                    </div>   
                 

                  
                </div>
               
               
            </div>}   
             
    </div>
  );
}

export default JudgeAdrCases;